import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '穿搭教程', path: '/category/fashion-tips' },
  { label: '美妆测评', path: '/category/beauty-review' },
  { label: '潮流单品', path: '/category/trending-items' },
  { label: '时尚文章', path: '/category/fashion-trends' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-play-circle-fill text-3xl text-primary-500"></i>
            </div>
            <span className="text-xl font-bold font-heading tracking-tight whitespace-nowrap">
              mogu视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-600 bg-primary-100/70'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line mr-1"></i>
              下载App
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome
                ? 'text-foreground-800 hover:bg-background-200/70'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-scale-in">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="mt-2 px-4 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium text-center transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line mr-1"></i>
              下载App
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}